import { Pixel } from "@securionpay-internal/commons-js";
import { TRACKER_URL } from "./env";

export default class Tracker {

    key?: string;
    merchantId?: string;
    jsId: string;
    paymentUserAgent: string;
    eventCount: number;
    referrer: string;

    constructor(jsId: string, paymentUserAgent: string, referrer: string, key?: string, merchantId?: string) {
        this.jsId = jsId;
        this.paymentUserAgent = paymentUserAgent;
        this.eventCount = 0;
        this.referrer = referrer;
        this.key = key;
        this.merchantId = merchantId;
    }

    trackException(name, exception: Error | any, additionalPayload?: Record<string, any>) {
        try {
            this.track(name, {
                ...(additionalPayload || {}),
                'exception-message': exception?.message
            });
        } catch (e) {
            // ensure tracker errors don't blow up processing - should not happen
            console.error(name, e);
        }
    }

    track(name, payload?) {
        try {
            let pixel = new Pixel(TRACKER_URL, this.key, this.jsId);
            const finalPayload = {
                paymentUserAgent: this.paymentUserAgent,
                referrer: this.referrer,
                ...payload
            };
            if (this.merchantId) {
                finalPayload['merchantId'] = this.merchantId
            }
            let eventCount = ++ this.eventCount;
            pixel.get(name, eventCount, finalPayload)
        } catch (e) {
            // ensure tracker errors don't blow up processing - should not happen
            console.error(name, e);
        }
        return Promise.resolve();
    }

    setKey(key) {
        this.key = key;
    }

    setMerchantId(merchantId) {
        this.merchantId = merchantId;
    }
}